import { createFileRoute, useNavigate, Link } from "@tanstack/react-router";
import { PsychrometricsPage } from "@charphq/ui/components/psychrometrics/psychrometrics-page";

// Loose strings by design: the route guarantees the *shape* of the search object, and the page
// validates the *meaning* of each value (unknown period, stale envelope id, half-picked range), so
// a hand-edited or bookmarked URL degrades to a sensible default instead of failing to parse.
type Search = {
  period?: string;
  start?: string;
  end?: string;
  customerId?: string;
  projectId?: string;
  deploymentId?: string;
  colorBy?: string;
  envelope?: string;
};

export const Route = createFileRoute("/psychrometrics")({
  component: PsychrometricsRoute,
  validateSearch: (search: Record<string, unknown>): Search => ({
    period: search.period as string | undefined,
    start: search.start as string | undefined,
    end: search.end as string | undefined,
    customerId: search.customerId as string | undefined,
    projectId: search.projectId as string | undefined,
    deploymentId: search.deploymentId as string | undefined,
    colorBy: search.colorBy as string | undefined,
    envelope: search.envelope as string | undefined,
  }),
});

function PsychrometricsRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  return (
    <PsychrometricsPage
      searchParams={search}
      onParamsChange={(next) => navigate({ to: "/psychrometrics", search: next, replace: true })}
      Link={Link}
    />
  );
}
